package org.gymly.auth

import kotlinx.browser.localStorage

actual object AuthPersistence {
    private fun tokenKey(kind: StoredAuthKind): String = when (kind) {
        StoredAuthKind.ADMIN -> "gymly.auth.admin"
        StoredAuthKind.CLIENT -> "gymly.auth.client"
    }

    actual fun save(kind: StoredAuthKind, token: String) {
        localStorage.setItem(tokenKey(kind), token)
        saveLastKind(kind)
    }

    actual fun load(kind: StoredAuthKind): String? =
        localStorage.getItem(tokenKey(kind))

    actual fun clear(kind: StoredAuthKind) {
        localStorage.removeItem(tokenKey(kind))
    }

    actual fun clearAll() {
        StoredAuthKind.entries.forEach { clear(it) }
        localStorage.removeItem(LAST_KIND_KEY)
        clearLastActivityAt()
    }

    actual fun saveLastKind(kind: StoredAuthKind) {
        localStorage.setItem(LAST_KIND_KEY, kind.name)
    }

    actual fun loadLastKind(): StoredAuthKind? =
        localStorage.getItem(LAST_KIND_KEY)?.let { name ->
            StoredAuthKind.entries.firstOrNull { it.name == name }
        }

    actual fun saveLastActivityAt(epochMs: Long) {
        localStorage.setItem(LAST_ACTIVITY_KEY, epochMs.toString())
    }

    actual fun loadLastActivityAt(): Long? =
        localStorage.getItem(LAST_ACTIVITY_KEY)?.toLongOrNull()

    actual fun clearLastActivityAt() {
        localStorage.removeItem(LAST_ACTIVITY_KEY)
    }

    private const val LAST_KIND_KEY = "gymly.auth.last"
    private const val LAST_ACTIVITY_KEY = "gymly.auth.lastActivity"
}
